import React from 'react';

import FormElement from '../index';
import FormFieldError from '../../FormFieldError';
import Slider from '../../Slider';


function FormSlider(props) {

    return (
        <FormElement {...props}>
            <Slider {...props}/>
            <FormFieldError error={props.error}/>
        </FormElement>
    );
}


FormSlider.propTypes = {
    ...FormElement.propTypes,
    ...Slider.propTypes
};

FormSlider.defaultProps = {
    ...FormElement.defaultProps,
    ...Slider.defaultProps
};


export default FormSlider;
